import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  makeStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  // Slider,
  withStyles,
  FormControlLabel,
  Checkbox,
  Hidden,
  useMediaQuery,
  useTheme,
  Divider,
} from "@material-ui/core";
import Slider from "@mui/material/Slider";
// import Skeleton from '@material-ui/lab/Skeleton';
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import TitleText from "../../components/reusableComponents/TitleText";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import BodyText from "../../components/reusableComponents/BodyText";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import InfiniteScroll from "react-infinite-scroll-component";
import FlightDetailModal from "../../components/reusableComponents/FlightDetailModal";
import h1 from "../../assets/images/h1.png";
import h2 from "../../assets/images/h2.jpg";
import h3 from "../../assets/images/h3.png";
import h4 from "../../assets/images/h4.png";
import h5 from "../../assets/images/h5.png";
import flightrun from "../../assets/images/flightrun.png";
import { setFlightId, toggleFlightModal } from "../../reducers/UiReducer";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import { useHistory, useLocation } from "react-router-dom";
import {
  AddSearchFlightDispatch,
  SearchEtravFormDispatch,
  SearchFormDispatch,
  searchSuccess,
  searchSuccessEtrav,
} from "../../reducers/HomeReducer";
import Drawers from "../../components/Drawers";
import Login from "../../components/reusableComponents/Login";
import OnewayForm from "../../form/OneWayFlightForm";
import {
  FlightFareRuleDispatch,
  FlightFareRuleEtravDispatch,
} from "../../reducers/HomeReducer";
import flightnotfound from "../../assets/images/flightnotfound.png";
import HeaderSection from "../../components/reusableComponents/HeaderSection";
import ErrorModal from "../../components/reusableComponents/ErrorModal";
import SkeletonOneway from "../../components/reusableComponents/SkeletonOneway";
import OneWayMobileRow from "../Mobile/OneWayMobileRow";
import OneWayDesktopRow from "../../components/reusableComponents/OneWayDesktopRow";
import SearchFlight from "../../form/SearchFlight";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiChip-sizeSmall": {
      height: 36,
    },
  },
  accodin: {
    "& .MuiAccordionSummary-content": {
      justifyContent: "space-between",
    },
  },
  searhform: {
    // backgroundImage: `url(${Home})`,
    // height: 272,
    // backgroundSize: 'cover',
    // backgroundRepeat: 'no-repeat',

    paddingTop: 84,
    paddingBottom: 30,
    backgroundColor: "midnightblue",
    [theme.breakpoints.down("md")]: {
      height: 508,
    },
    [theme.breakpoints.down("xs")]: {
      height: 590,
    },
  },
  radio: {
    "& .MuiTypography-body1": {
      fontSize: 13,
    },
  },
}));

const GreenCheckbox = withStyles({
  root: {
    color: "rgb(239, 51, 57)",
    "&$checked": {
      color: "rgb(239, 51, 57)",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);
const OneWay = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [expanded, setExpanded] = React.useState("");
  const [check, setCheck] = useState(false);
  const [net, setNet] = useState(false);
  const [check2, setCheck2] = useState(false);
  const [check3, setCheck3] = useState(false);
  const [check4, setCheck4] = useState(false);
  const [check5, setCheck5] = useState(false);
  const [rule, SetRule] = useState(false);
  const [scrollVal, SetScrollVal] = useState(10);
  const [scrollValResult, SetScrollValResult] = useState(10);
  const [hasMoreresult, SethasMoreResult] = useState(true);
  const [hasMorefilterData, SethasMoreFilterData] = useState(true);
  const [result, setResult] = useState([]);
  const history = useHistory();
  const theme = useTheme();
  const location = useLocation();
  const [toggle, setToggle] = useState(false);
  const { search, loading, onewayflightdata, onewayflightdataEtrav, tripjack } =
    useSelector((state) => state.home);
  const { selectedOrigin, selectedDepart } = useSelector((state) => state.ui);
  const { agentlogin } = useSelector((state) => state.user);
  const [stop1, setStop1] = useState(false);
  const [value, setValue] = React.useState([1000, 100000]);

  const [stop2, setStop2] = useState(false);
  const [stop3, setStop3] = useState(false);
  const [morning, setMorning] = useState(false);
  const [dophar, setDOphar] = useState(false);
  const { AdultCount, ChildCount, InfantCount } = location.state.body;
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const matches2 = useMediaQuery(theme.breakpoints.down("xs"));
  const handleSlider = (event, newValue) => {
    setValue(newValue);
    console.log(newValue);
    setResult([]);
    let combineflightData = [];
    let checkDataTBO = [];
    let checkDataEtrav = [];
    let filterCombineData = [];
    if (onewayflightdata && newValue) {
      onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].map((item) => {
          let a = item.Fare.Total_Amount;
          let b = newValue[0];
          let c = newValue[1];
          if (a >= b && a <= c) {
            checkDataTBO.push({
              ...item,
            });
          }
        });
    }
    if (onewayflightdataEtrav && newValue) {
      onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails[0] &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
          let a = item.Fares.Total_Amount;
          let b = newValue[0];
          let c = newValue[1];
          if (a >= b && a <= c) {
            checkDataEtrav.push({
              ...item,
            });
          }
        });
    }
    combineflightData = [...checkDataTBO, ...checkDataEtrav];
    console.log("checkData", combineflightData);
    filterCombineData =
      combineflightData &&
      combineflightData.length > 0 &&
      combineflightData.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(Math.round(a.Fare.Total_Amount))
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : Number(Math.round(a.Fare.Total_Amount));
        let second = b.Fare
          ? Number(Math.round(b.Fare.Total_Amount))
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          : Number(Math.round(b.Fare.Total_Amount));
        return first - second;
      });
    setResult(filterCombineData);
    console.log("Filter",filterCombineData)
    SetScrollValResult(10);

    // console.log('Slider Value', checkData);
  };
  const handleNetFare = (event) => {
    setNet(event.target.checked);
    console.log(event.target.name);
  };
  const handleCheck = (event) => {
    setCheck(event.target.checked);
    setResult([]);
    console.log(event.target.checked);
    SetRule(event.target.checked);
    console.log(event.target.name);

    let combineflightData = [];
    let checkDataTBO = [];
    let checkDataEtrav = [];
    let filterCombineData = [];
    if (onewayflightdata && event.target.name) {
      onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].map((item) => {
          if (item.AirlineCode === event.target.name) {
            checkDataTBO.push({
              ...item,
            });
          }
        });
    }
    console.log("checkDataTBO", checkDataTBO);
    if (onewayflightdataEtrav && event.target.name) {
      onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
          if (item.Airline_Code === event.target.name) {
            checkDataEtrav.push({
              ...item,
            });
          }
        });
    }
    console.log("checkDataEtrav", checkDataEtrav);
    combineflightData = [...checkDataTBO, ...checkDataEtrav];
    console.log("checkData", combineflightData);
    filterCombineData =
      combineflightData &&
      combineflightData.length > 0 &&
      combineflightData.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(Math.round(a.Fare.Total_Amount))
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : Number(Math.round(a.Fare.Total_Amount));
        let second = b.Fare
          ? Number(Math.round(b.Fare.Total_Amount))
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          : Number(Math.round(b.Fare.Total_Amount));
        return first - second;
      });
    console.log(check);
    if (combineflightData.length > 0) {
      if (check) {
        setResult([]);
        SetScrollVal(10);
        SetScrollValResult(10);
      } else {
        setResult(...result, filterCombineData);
      }
    }
  };
  const handleCheckGO = (event) => {
    setCheck2(event.target.checked);
    SetRule(event.target.checked);
    console.log(event.target.name);
    let combineflightData = [];
    let checkDataTBO = [];
    let checkDataEtrav = [];
    let filterCombineData = [];
    if (onewayflightdata && event.target.name) {
      onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].map((item) => {
          if (item.AirlineCode === event.target.name) {
            checkDataTBO.push({
              ...item,
            });
          }
        });
    }
    console.log("checkDataTBO", checkDataTBO);
    if (onewayflightdataEtrav && event.target.name) {
      onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
          if (item.Airline_Code === event.target.name) {
            checkDataEtrav.push({
              ...item,
            });
          }
        });
    }
    console.log("checkDataEtrav", checkDataEtrav);
    combineflightData = [...checkDataTBO, ...checkDataEtrav];
    console.log("checkData", combineflightData);
    filterCombineData =
      combineflightData &&
      combineflightData.length > 0 &&
      combineflightData.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(Math.round(a.Fare.Total_Amount))
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : Number(Math.round(a.Fare.Total_Amount));
        let second = b.Fare
          ? Number(Math.round(b.Fare.Total_Amount))
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          : Number(Math.round(b.Fare.Total_Amount));
        return first - second;
      });
    if (combineflightData.length > 0) {
      if (check2) {
        setResult([]);
        SetScrollVal(10);
        SetScrollValResult(10);
      } else {
        setResult(...result, filterCombineData);
      }
    }
  };
  const handleCheckIndigo = (event) => {
    setCheck3(event.target.checked);
    SetRule(event.target.checked);
    console.log(event.target.name);
    let combineflightData = [];
    let checkDataTBO = [];
    let checkDataEtrav = [];
    let filterCombineData = [];
    if (onewayflightdata && event.target.name) {
      onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].map((item) => {
          if (item.AirlineCode === event.target.name) {
            checkDataTBO.push({
              ...item,
            });
          }
        });
    }
    console.log("checkDataTBO", checkDataTBO);
    if (onewayflightdataEtrav && event.target.name) {
      onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
          if (item.Airline_Code === event.target.name) {
            checkDataEtrav.push({
              ...item,
            });
          }
        });
    }
    console.log("checkDataEtrav", checkDataEtrav);
    combineflightData = [...checkDataTBO, ...checkDataEtrav];
    console.log("checkData", combineflightData);
    filterCombineData =
      combineflightData &&
      combineflightData.length > 0 &&
      combineflightData.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(Math.round(a.Fare.Total_Amount))
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : Number(Math.round(a.Fare.Total_Amount));
        let second = b.Fare
          ? Number(Math.round(b.Fare.Total_Amount))
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          : Number(Math.round(b.Fare.Total_Amount));
        return first - second;
      });
    if (combineflightData.length > 0) {
      if (check3) {
        setResult([]);
        SetScrollVal(10);
        SetScrollValResult(10);
      } else {
        setResult(...result, filterCombineData);
      }
    }
  };
  const handleCheckAir = (event) => {
    setCheck4(event.target.checked);
    SetRule(event.target.checked);
    console.log(event.target.name);
    let combineflightData = [];
    let checkDataTBO = [];
    let checkDataEtrav = [];
    let filterCombineData = [];
    if (onewayflightdata && event.target.name) {
      onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].map((item) => {
          if (item.AirlineCode === event.target.name) {
            checkDataTBO.push({
              ...item,
            });
          }
        });
    }
    console.log("checkDataTBO", checkDataTBO);
    if (onewayflightdataEtrav && event.target.name) {
      onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
          if (item.Airline_Code === event.target.name) {
            checkDataEtrav.push({
              ...item,
            });
          }
        });
    }
    console.log("checkDataEtrav", checkDataEtrav);
    combineflightData = [...checkDataTBO, ...checkDataEtrav];
    console.log("checkData", combineflightData);
    filterCombineData =
      combineflightData &&
      combineflightData.length > 0 &&
      combineflightData.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(Math.round(a.Fare.Total_Amount))
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : Number(Math.round(a.Fare.Total_Amount));
        let second = b.Fare
          ? Number(Math.round(b.Fare.Total_Amount))
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          : Number(Math.round(b.Fare.Total_Amount));
        return first - second;
      });
    if (combineflightData.length > 0) {
      if (check4) {
        setResult([]);
        SetScrollVal(10);
        SetScrollValResult(10);
      } else {
        setResult(...result, filterCombineData);
      }
    }
  };
  const handleCheckVistara = (event) => {
    setCheck5(event.target.checked);
    SetRule(event.target.checked);
    console.log(event.target.name);
    let combineflightData = [];
    let checkDataTBO = [];
    let checkDataEtrav = [];
    let filterCombineData = [];
    if (onewayflightdata && event.target.name) {
      onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].map((item) => {
          if (item.AirlineCode === event.target.name) {
            checkDataTBO.push({
              ...item,
            });
          }
        });
    }
    console.log("checkDataTBO", checkDataTBO);
    if (onewayflightdataEtrav && event.target.name) {
      onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
          if (item.Airline_Code === event.target.name) {
            checkDataEtrav.push({
              ...item,
            });
          }
        });
    }
    console.log("checkDataEtrav", checkDataEtrav);
    combineflightData = [...checkDataTBO, ...checkDataEtrav];
    console.log("checkData", combineflightData);
    filterCombineData =
      combineflightData &&
      combineflightData.length > 0 &&
      combineflightData.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(Math.round(a.Fare.Total_Amount))
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : Number(Math.round(a.Fare.Total_Amount));
        let second = b.Fare
          ? Number(Math.round(b.Fare.Total_Amount))
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          : Number(Math.round(b.Fare.Total_Amount));
        return first - second;
      });
    if (combineflightData.length > 0) {
      if (check5) {
        setResult([]);
        SetScrollVal(10);
        SetScrollValResult(10);
      } else {
        setResult(...result, filterCombineData);
      }
    }
  };
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  function valuetext(value) {
    return `${value}°C`;
  }
  function hrToMin(a, b) {
    let hours = Math.trunc(a * 60);
    let minutes = b;
    return hours + minutes;
  }
  function convertH2M(timeInHour) {
    console.log(timeInHour);
    var timeParts = timeInHour.split(":");
    return Number(timeParts[0]) * 60 + Number(timeParts[1]);
  }
  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + " hr and " + rminutes + " min.";
  }
  console.log(location.state);
  console.log("CheckValue", check);
  console.log("Check2Value", check2);
  console.log("Rule", rule);
  let combineflightData = [];
  let demo = [];
  let filterData = [];
  let flt = [];
  if (loading) {
    console.log("Loading");
  } else {
    if (
      onewayflightdata &&
      onewayflightdata.status === 200 &&
      onewayflightdataEtrav &&
      onewayflightdataEtrav.status === 200
    ) {
      let tbo =
        onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0];
      let Etrav =
        onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights;
      if (Etrav.length > 0 && tbo.length > 0) {
        combineflightData = [...tbo, ...Etrav];
      } else if (tbo.length > 0) {
        combineflightData = [...tbo];
      } else if (Etrav.length > 0) {
        combineflightData = [...Etrav];
      }

      console.log("combine", combineflightData);

      filterData =
        combineflightData &&
        combineflightData.length > 0 &&
        combineflightData.slice().sort((a, b) => {
          let first = a.Fare
            ? Number(Number(Math.round(a.Fare.Total_Amount))-Number(Math.round(a.Fare.MFB_Discount)))
            : a.Fares
            ? Number(Math.round(a.Fares.Total_Amount))
            : Number(Number(Math.round(a.Fare.Total_Amount))-Number(Math.round(a.Fare.MFB_Discount)))
          let second = b.Fare
            ? Number(Number(Math.round(b.Fare.Total_Amount))-Number(Math.round(b.Fare.MFB_Discount)))
            : b.Fares
            ? Number(Math.round(b.Fares.Total_Amount))
            : Number(Number(Math.round(b.Fare.Total_Amount))-Number(Math.round(b.Fare.MFB_Discount)))
          return first - second;
        });
    } else if (
      onewayflightdata &&
      onewayflightdata.status === 200 &&
      onewayflightdataEtrav &&
      onewayflightdataEtrav.status === 202
    ) {
      filterData =
        onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].slice().sort((a, b) => {
          let first = Number(Number(Math.round(a.Fare.Total_Amount))-Number(Math.round(a.Fare.MFB_Discount)))
          let second = Number(Number(Math.round(b.Fare.Total_Amount))-Number(Math.round(b.Fare.MFB_Discount)))
          return first - second;
        });
    } else if (
      onewayflightdataEtrav &&
      onewayflightdataEtrav.status === 200 &&
      onewayflightdata &&
      onewayflightdata.status === 202
    ) {
      filterData =
        onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.slice().sort(
          (a, b) => {
            let first = Number(Math.round(a.Fares.Total_Amount));
            let second = Number(Math.round(b.Fares.Total_Amount));

            return first - second;
          }
        );
    } else if (
      onewayflightdata &&
      onewayflightdata.status === 200 &&
      onewayflightdataEtrav === null
    ) {
      filterData =
        onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].slice().sort((a, b) => {
          let first = Number(Number(Math.round(a.Fare.Total_Amount))-Number(Math.round(a.Fare.MFB_Discount)))
          let second = Number(Number(Math.round(b.Fare.Total_Amount))-Number(Math.round(b.Fare.MFB_Discount)))
          return first - second;
        });
    } else if (
      onewayflightdata === null &&
      onewayflightdataEtrav &&
      onewayflightdataEtrav.status === 200
    ) {
      filterData =
        onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.slice().sort(
          (a, b) => {
            let first = Number(Math.round(a.Fares.Total_Amount));
            let second = Number(Math.round(b.Fares.Total_Amount));

            return first - second;
          }
        );
    }
  }
  console.log("FLT", flt);
  console.log("TBO", combineflightData);
  console.log("Demo", demo);
  // let filterData = [];
  // filterData =
  // 	combineflightData &&
  // 	combineflightData.length > 0 &&
  // 	combineflightData.slice().sort((a, b) => {
  // 		let first = a.Fare
  // 			? a.Fare.OfferedFare
  // 			: a.Fares[0].FareDetails
  // 			? a.Fares[0].FareDetails[0].Total_Amount
  // 			: a.Fare.OfferedFare;
  // 		let second = b.Fare
  // 			? b.Fare.OfferedFare
  // 			: b.Fares[0].FareDetails
  // 			? b.Fares[0].FareDetails[0].Total_Amount
  // 			: b.Fare.OfferedFare;
  // 		return first - second;
  // 	});
  // console.log('fILTER', filterData);

  if (onewayflightdata) {
  }

  console.log("FilterData", filterData);

  const fetchMoreData = () => {
    if (scrollVal >= filterData.length) {
      SethasMoreFilterData(false);
    }

    setTimeout(() => {
      SetScrollVal(scrollVal + 5);
    }, 500);
  };
  const fetchMoreDataResult = () => {
    if (scrollValResult >= filterData.length) {
      SethasMoreResult(false);
    }
    setTimeout(() => {
      SetScrollValResult(scrollValResult + 5);
    }, 500);
  };

  useEffect(() => {
    if (location.state) {
      dispatch(SearchFormDispatch(location.state.body, history));
      dispatch(SearchEtravFormDispatch(location.state.body));
      dispatch(AddSearchFlightDispatch(location.state.body));
    }
  }, [dispatch]);

  const handleZero = () => {
    SetRule(true);
    let combineflightData = [];
    let checkDataTBO = [];
    let newFilter = [];
    let checkDataEtrav = [];
    let filterCombineData = [];
    if (onewayflightdata) {
      onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].map((item) => {
          if (item.Segments[0].length === 1) {
            checkDataTBO.push({
              ...item,
            });
          }
        });
    }
    if (onewayflightdataEtrav) {
      onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails[0] &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
          if (item.Segments.length === 1) {
            checkDataEtrav.push({
              ...item,
            });
          }
        });
    }
    combineflightData = [...checkDataTBO, ...checkDataEtrav];
    filterCombineData =
      combineflightData &&
      combineflightData.length > 0 &&
      combineflightData.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(Number(Math.round(a.Fare.Total_Amount))-Number(Math.round(a.Fare.MFB_Discount)))
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : Number(Number(Math.round(a.Fare.Total_Amount))-Number(Math.round(a.Fare.MFB_Discount)))
        let second = b.Fare
          ? Number(Number(Math.round(b.Fare.Total_Amount))-Number(Math.round(b.Fare.MFB_Discount)))
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          : Number(Number(Math.round(b.Fare.Total_Amount))-Number(Math.round(b.Fare.MFB_Discount)))
        return first - second;
      });
    if (result.length > 0) {
      result.map((r) => {
        newFilter.push({
          ...r,
        });
      });
      filterCombineData.map((fl) => {
        newFilter.push({
          ...fl,
        });
      });
    } else {
      filterCombineData.map((fl) => {
        newFilter.push({
          ...fl,
        });
      });
    }
    console.log("ResultNEw", newFilter);
    console.log("TBO", checkDataTBO);
    console.log("Etrav", checkDataEtrav);
    console.log(combineflightData);
    if (stop1) {
      if (stop2 || stop3) {
      } else {
        setResult([]);
        SetScrollVal(10);
        SetScrollValResult(10);
      }
    } else {
      setResult(newFilter);
    }
  };
  const handleOne = () => {
    SetRule(true);
    let combineflightData = [];
    let newFilter = [];
    let checkDataTBO = [];
    let checkDataEtrav = [];
    let filterCombineData = [];
    if (onewayflightdata) {
      onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].map((item) => {
          if (item.Segments[0].length === 2) {
            checkDataTBO.push({
              ...item,
            });
          }
        });
    }
    if (onewayflightdataEtrav) {
      onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails[0] &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
          if (item.Segments.length === 2) {
            checkDataEtrav.push({
              ...item,
            });
          }
        });
    }
    combineflightData = [...checkDataTBO, ...checkDataEtrav];
    console.log("TBO", checkDataTBO);
    console.log("Etrav", checkDataEtrav);
    console.log(combineflightData);
    filterCombineData =
      combineflightData &&
      combineflightData.length > 0 &&
      combineflightData.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(Number(Math.round(a.Fare.Total_Amount))-Number(Math.round(a.Fare.MFB_Discount)))
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : Number(Number(Math.round(a.Fare.Total_Amount))-Number(Math.round(a.Fare.MFB_Discount)))
        let second = b.Fare
          ? Number(Number(Math.round(b.Fare.Total_Amount))-Number(Math.round(b.Fare.MFB_Discount)))
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          :Number(Number(Math.round(b.Fare.Total_Amount))-Number(Math.round(b.Fare.MFB_Discount)))
        return first - second;
      });
    if (result.length > 0) {
      result.map((r) => {
        newFilter.push({
          ...r,
        });
      });
      filterCombineData.map((fl) => {
        newFilter.push({
          ...fl,
        });
      });
    } else {
      filterCombineData.map((fl) => {
        newFilter.push({
          ...fl,
        });
      });
    }

    console.log("ResultNEw", newFilter);
    if (stop2) {
      if (stop1 || stop3) {
      } else {
        setResult([]);
        SetScrollVal(10);
        SetScrollValResult(10);
      }
    } else {
      setResult(newFilter);
    }
  };
  const handleTwo = () => {
    SetRule(true);
    let combineflightData = [];
    let newFilter = [];
    let checkDataTBO = [];
    let checkDataEtrav = [];
    let filterCombineData = [];
    if (onewayflightdata) {
      onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].map((item) => {
          if (item.Segments[0].length === 3) {
            checkDataTBO.push({
              ...item,
            });
          }
        });
    }
    if (onewayflightdataEtrav) {
      onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails[0] &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
          if (item.Segments.length === 3) {
            checkDataEtrav.push({
              ...item,
            });
          }
        });
    }
    combineflightData = [...checkDataTBO, ...checkDataEtrav];
    console.log("TBO", checkDataTBO);
    console.log("Etrav", checkDataEtrav);
    console.log(combineflightData);
    filterCombineData =
      combineflightData &&
      combineflightData.length > 0 &&
      combineflightData.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(Number(Math.round(a.Fare.Total_Amount))-Number(Math.round(a.Fare.MFB_Discount)))
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : Number(Number(Math.round(a.Fare.Total_Amount))-Number(Math.round(a.Fare.MFB_Discount)))
        let second = b.Fare
          ? Number(Number(Math.round(b.Fare.Total_Amount))-Number(Math.round(b.Fare.MFB_Discount)))
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          : Number(Number(Math.round(b.Fare.Total_Amount))-Number(Math.round(b.Fare.MFB_Discount)))
        return first - second;
      });
    if (result.length > 0) {
      result.map((r) => {
        newFilter.push({
          ...r,
        });
      });
      filterCombineData.map((fl) => {
        newFilter.push({
          ...fl,
        });
      });
    } else {
      filterCombineData.map((fl) => {
        newFilter.push({
          ...fl,
        });
      });
    }
    console.log("ResultNEw", newFilter);
    if (stop3) {
      if (stop1 || stop2) {
      } else {
        setResult([]);
        SetScrollVal(10);
        SetScrollValResult(10);
      }
    } else {
      setResult(newFilter);
    }
  };
  const handlemorning = () => {
    SetRule(true);
    let checkData = [];
    if (onewayflightdata) {
      onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].map((item) => {
          console.log(
            item.Segments[0].slice(0, 1).map((i) => {
              return i.Origin.DepTime.substr(11, 2);
            })
          );
          console.log(
            "Dept",
            item.Segments[0].slice(0, 1).map((i) => {
              return i.Destination.ArrTime.substr(11, 2);
            })
          );
          let a = item.Segments[0].slice(0, 1).map((i) => {
            return i.Origin.DepTime.substr(11, 2);
          });
          let b = item.Segments[0].slice(0, 1).map((i) => {
            return i.Destination.ArrTime.substr(11, 2);
          });
          if (a >= 5 && b <= 12) {
            checkData.push({
              ...item,
            });
          }
        });
    }
    if (morning) {
      setResult([]);
      SetScrollVal(10);
      SetScrollValResult(10);
    } else {
      setResult(checkData);
    }
    console.log("Morning", checkData);
  };
  const handledophar = () => {
    SetRule(true);
    let checkData = [];
    if (onewayflightdata) {
      onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].map((item) => {
          console.log(
            item.Segments[0].slice(0, 1).map((i) => {
              return i.Origin.DepTime.substr(11, 2);
            })
          );
          console.log(
            "Dept",
            item.Segments[0].slice(0, 1).map((i) => {
              return i.Destination.ArrTime.substr(11, 2);
            })
          );
          let a = item.Segments[0].slice(0, 1).map((i) => {
            return i.Origin.DepTime.substr(11, 2);
          });
          let b = item.Segments[0].slice(0, 1).map((i) => {
            return i.Destination.ArrTime.substr(11, 2);
          });
          if (a >= 12 && b <= 18) {
            checkData.push({
              ...item,
            });
          }
        });
    }
    if (dophar) {
      setResult([]);
      SetScrollVal(10);
      SetScrollValResult(10);
    } else {
      setResult(checkData);
    }
    console.log("Dophar", checkData);
  };
  console.log("ResultPart", result);
  console.log("stop1", stop1);
  console.log("stop2", stop2);
  console.log("stop3", stop3);
  return (
    <>
      {/* Header Starting */}
      <HeaderSection id={1} />
      {/* Header Ending */}

      {/* Oneway Form Starting */}
      {true ? (
        <Box
          styel={{
            visibility: true ? "hidden" : "visible",
            opacity: true ? 0 : 1,
            transition: true
              ? ""
              : "visibility 0s linear 0.33s, opacity 0.33s linear",
            transitionDelay: true ? "" : "0s",
          }}
          className={classes.searhform}
        >
          <Container>
            <OnewayForm />
            {/* <SearchFlight /> */}
          </Container>
        </Box>
      ) : (
        ""
      )}
      {/* Oneway Form Ending */}

      <Box style={{ background: "white" }}>
        {/* <Container> */}
        <Box style={{ padding: 20 }}>
          {loading ? (
            // <Skeleton variant='rectangular' width='100%' height={118} />
            <marquee direction="right">
              <img
                src={flightrun}
                style={{ width: 100, height: 32, marginTop: 10 }}
              />
            </marquee>
          ) : (
            <></>
            
          )}

          <Grid container style={{ marginTop: 20 }} spacing={2}>
            <Grid item xs={12} lg={2}>
              {/* {loading?<> <Box mt={'10px'}>
											<img src={h1} width='100%' height='216px'></img>
										</Box>
										<Box mt={'10px'}>
											<img src={h5} width='100%' height='216px'></img>
										</Box>
										<Box mt={'10px'}>
											<img src={h3} width='100%' height='216px'></img>
										</Box>
										<Box mt={'10px'}>
											<img src={h4} width='100%' height='216px'></img>
										</Box>
										<Box mt={'10px'}>
											<img src={h5} width='100%' height='216px'></img>
										</Box> </>: */}
              <Box
                style={{ border: "1px solid rgb(38 38 38 / 27%)", padding: 15 }}
              >
                <h4>Filter</h4>
                <Divider />
                <h5>Stop:</h5>
                <Box display={"flex"} alignItems="center">
                  <span>Non Stop</span>
                  <Box
                    onClick={() => {
                      handleZero();
                      stop1 ? setStop1(false) : setStop1(true);
                      rule ? SetRule(false) : SetRule(true);
                    }}
                    style={{
                      width: "40px",
                      padding: "6px 0px",
                      background: stop1 ? "rgb(239, 51, 57)" : "#eee",
                      color: stop1 ? "white" : "#666",
                      border: "1px solid #ddd",
                      borderRadius: "2px",
                      fontWeight: 700,
                      textAlign: "center",
                      cursor: "pointer",
                      marginLeft: 20,
                    }}
                  >
                    <BodyText textStyle={{ fontSize: 14 }}>0</BodyText>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  style={{ marginTop: 20 }}
                  alignItems="center"
                >
                  <span>1 Stop</span>
                  <Box
                    onClick={() => {
                      handleOne();
                      stop2 ? setStop2(false) : setStop2(true);
                      rule ? SetRule(false) : SetRule(true);
                    }}
                    style={{
                      width: "40px",
                      padding: "6px 0px",
                      background: stop2 ? "rgb(239, 51, 57)" : "#eee",
                      color: stop2 ? "white" : "#666",
                      border: "1px solid #ddd",
                      borderRadius: "2px",
                      fontWeight: 700,
                      textAlign: "center",
                      cursor: "pointer",
                      marginLeft: 40,
                    }}
                  >
                    <BodyText textStyle={{ fontSize: 14 }}>1</BodyText>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  style={{ marginTop: 20 }}
                  alignItems="center"
                >
                  <span>2+ Stop</span>
                  <Box
                    onClick={() => {
                      handleTwo();
                      stop3 ? setStop3(false) : setStop3(true);
                      rule ? SetRule(false) : SetRule(true);
                    }}
                    style={{
                      width: "40px",
                      padding: "6px 0px",
                      background: stop3 ? "rgb(239, 51, 57)" : "#eee",
                      color: stop3 ? "white" : "#666",
                      border: "1px solid #ddd",
                      borderRadius: "2px",
                      fontWeight: 700,
                      textAlign: "center",
                      cursor: "pointer",
                      marginLeft: 32,
                    }}
                  >
                    <BodyText textStyle={{ fontSize: 14 }}>2+</BodyText>
                  </Box>
                </Box>
                <Divider style={{ marginTop: 20 }} />
                <h4>Price:</h4>
                <Box>
                  <Slider
                    style={{ maxWidth: 500, color: "rgb(239, 51, 57)" }}
                    value={value}
                    min={1000}
                    max={100000}
                    aria-label="Default"
                    onChange={handleSlider}
                    valueLabelDisplay="auto"
                    aria-labelledby="non-linear-slider"
                    disableSwap
                  />
                  <Box display="flex" justifyContent="space-between">
                    <p>Min: {value[0]}</p>
                    <p>Max: {value[1]}</p>
                  </Box>
                </Box>
                <Divider style={{ marginTop: 20 }} />
                <h4>Airlines:</h4>
                <Box mt={matches ? "20px" : ""} className={classes.radio}>
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={check}
                        onChange={handleCheck}
                        name="SG"
                      />
                    }
                    label="SpiceJet"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={check2}
                        onChange={handleCheckGO}
                        name="G8"
                      />
                    }
                    label="GO FIRST"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={check3}
                        onChange={handleCheckIndigo}
                        name="6E"
                      />
                    }
                    label="Indigo"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={check4}
                        onChange={handleCheckAir}
                        name="I5"
                      />
                    }
                    label="Air Asia"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <GreenCheckbox
                        checked={check5}
                        onChange={handleCheckVistara}
                        name="UK"
                      />
                    }
                    label="Vistara"
                  />
                  <br />
                </Box>
                <Divider style={{ marginTop: 20 }} />
                <h4>Departure Time:</h4>
                <Box display="flex" mt={matches ? "20px" : ""}>
                  <Box
                    onClick={() => {
                      handlemorning();
                      morning ? setMorning(false) : setMorning(true);
                      rule ? SetRule(false) : SetRule(true);
                    }}
                    style={{
                      display: "block",
                      padding: "6px 10px",
                      textAlign: "center",
                      background: morning ? "rgb(239, 51, 57)" : "#8f8f8f",
                      color: morning ? "white" : "",
                      borderRight: "1px solid #ddd",
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    <WbSunnyIcon />
                    <Box>
                      <BodyText one textStyle={{ color: "white" }}>
                        05-12
                      </BodyText>
                    </Box>
                  </Box>
                  <Box
                    onClick={() => {
                      handledophar();
                      dophar ? setDOphar(false) : setDOphar(true);
                      rule ? SetRule(false) : SetRule(true);
                    }}
                    ml={"10px"}
                    style={{
                      display: "block",
                      padding: "6px 10px",
                      textAlign: "center",
                      borderRight: "1px solid #ddd",
                      fontWeight: 700,
                      cursor: "pointer",
                      background: dophar ? "rgb(239, 51, 57)" : "#8f8f8f",
                      color: dophar ? "white" : "",
                    }}
                  >
                    <WbSunnyIcon />
                    <Box>
                      <BodyText one textStyle={{ color: "white" }}>
                        12-18
                      </BodyText>
                    </Box>
                  </Box>
                </Box>
              </Box>
              {/* } */}

              {/* <Box>
											<img src={flightpro} width='100%' height='216px'></img>
										</Box> */}
            </Grid>
            <Grid item xs={12} md={9} lg={10}>
              <Box
                justifyContent="space-between"
                alignItems="center"
                display="flex"
              >
                {matches ? (
                  <h3>{`Flights from ${selectedOrigin.city_name} to ${selectedDepart.city_name}(${filterData.length})`}</h3>
                ) : (
                  <h1>{`Flights from ${selectedOrigin.city_name} to ${selectedDepart.city_name}(${filterData.length})`}</h1>
                )}
                <Hidden only={["sm", "xs"]}>
                  <Box>
                    {agentlogin ? (
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="end"
                      >
                        {/* <h5>Net Fare</h5> */}
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={net}
                              onChange={handleNetFare}
                              name="net"
                              style={{ marginLeft: 20 }}
                            />
                          }
                          // label='SpiceJet'
                        />
                      </Box>
                    ) : (
                      ""
                    )}
                    {/* <h4 style={{ marginLeft: 10, margin: 0 }}>
										{`${new Date(
											location.state.body.Segments[0].PreferredDepartureTime
										).toLocaleString('en-us', {
											weekday: 'short',
										})} ,  ${new Date(
											location.state.body.Segments[0].PreferredDepartureTime
										).getDate()} ${new Date(
											location.state.body.Segments[0].PreferredDepartureTime
										).toLocaleString('en-us', {
											month: 'short',
										})},2022`}
									</h4> */}
                    {/* <span style={{  margin: 0, marginRight: 5 }}>
											{location.state.body.AdultCount} Adult
										</span>
										<span
											style={{
												marginLeft: 10,
												margin: 0,
												marginRight: 5,
											}}>
											{location.state.body.ChildCount} Child
										</span>
										<span
											style={{
												marginLeft: 10,
												margin: 0,
												marginRight: 5,
											}}>
											{location.state.body.InfantCount} Infant
										</span>
										<span style={{ marginLeft: 10,  margin: 0 }}>
											ECONOMY
										</span> */}
                  </Box>
                </Hidden>

                {/* <h6 style={{ margin: 0 }}>
										{filterData.length} Flights Found
									</h6> */}
              </Box>

              {loading ? (
                [0, 1, 2, 3, 4].map((i) => {
                  return <SkeletonOneway />;
                })
              ) : rule || (result && result.length > 0) ? (
                result && result.length > 0 ? (
                  <InfiniteScroll
                    dataLength={scrollValResult}
                    next={fetchMoreDataResult}
                    hasMore={hasMoreresult}
                    loader={<h4>Loading...</h4>}
                    endMessage={
                      <p style={{ textAlign: "center" }}>
                        <b>No More Flights</b>
                      </p>
                    }
                  >
                    {result.map((item, index) => {
                      return index < scrollValResult ? (
                        matches ? (
                          <OneWayMobileRow
                            item={item}
                            loading={loading}
                            timeConvert={timeConvert}
                            location={location}
                            net={net}
                            onewayflightdata={onewayflightdata}
                            onewayflightdataEtrav={onewayflightdataEtrav}
                            convertH2M={convertH2M}
                          />
                        ) : (
                          <>
                            <OneWayDesktopRow
                              item={item}
                              loading={loading}
                              timeConvert={timeConvert}
                              location={location}
                              onewayflightdata={onewayflightdata}
                              onewayflightdataEtrav={onewayflightdataEtrav}
                              convertH2M={convertH2M}
                              net={net}
                            />
                          </>
                        )
                      ) : (
                        ""
                      );
                    })}
                  </InfiniteScroll>
                ) : (
                  <div
                    style={{
                      padding: "30px 15px",
                      background: "white",
                      borderBottom: "1px solid #e6e6e6",
                      textAlign: "center",
                    }}
                  >
                    <img src={flightnotfound}></img>
                    <p style={{ fontSize: "24px", textAlign: "center" }}>
                      Sorry No Flight Found !!
                    </p>
                  </div>
                )
              ) : filterData && filterData.length > 0 ? (
                <InfiniteScroll
                  dataLength={scrollVal}
                  next={fetchMoreData}
                  hasMore={hasMorefilterData}
                  loader={<h4 style={{ textAlign: "center" }}>Loading...</h4>}
                  endMessage={
                    <p style={{ textAlign: "center" }}>
                      <b>No More Flights</b>
                    </p>
                  }
                >
                  {filterData.map((item, index) => {
                    return index < scrollVal ? (
                      matches ? (
                        <OneWayMobileRow
                          item={item}
                          loading={loading}
                          timeConvert={timeConvert}
                          location={location}
                          onewayflightdata={onewayflightdata}
                          onewayflightdataEtrav={onewayflightdataEtrav}
                          convertH2M={convertH2M}
                          net={net}
                        />
                      ) : (
                        <OneWayDesktopRow
                          item={item}
                          loading={loading}
                          timeConvert={timeConvert}
                          location={location}
                          onewayflightdata={onewayflightdata}
                          onewayflightdataEtrav={onewayflightdataEtrav}
                          convertH2M={convertH2M}
                          net={net}
                        />
                      )
                    ) : (
                      ""
                    );
                  })}
                </InfiniteScroll>
              ) : (
                <>
                  <div
                    style={{
                      padding: "30px 15px",
                      background: "white",
                      borderBottom: "1px solid #e6e6e6",
                      textAlign: "center",
                    }}
                  >
                    <img src={flightnotfound}></img>
                    <p style={{ fontSize: "24px", textAlign: "center" }}>
                      Sorry No Flight Found !!
                    </p>
                  </div>
                  {/* {[0, 1, 2, 3, 4].map((i) => {
												return <SkeletonOneway />;
											})} */}
                </>
              )}
            </Grid>
          </Grid>
        </Box>
        {/* </Container> */}
      </Box>
      <FlightDetailModal />
      <Drawers />
      <Login />
      <ErrorModal />
    </>
  );
};

export default OneWay;
